import Modal from '@components/modal/Modal';
import useRevokeAdminMfa from './hooks/useRevokeAdminMfa';
import Form from '@components/form/Form';
import { AdminUser } from 'src/types/shared/AdminUser';

const RevokeAdminMfaModal: React.FC<RevokeAdminMfaModalProps> = ({ user }) => {
    const { handleSubmit, closeModal, isPosting, error } = useRevokeAdminMfa(user);

    return (
        <Modal title={`Revoke MFA for ${user.firstName} ${user.lastName}`} closeModal={closeModal}>
            <p>Are you sure you want to revoke this user's Multi-Factor Authentication (MFA)?</p>
            <Form
                onSubmit={handleSubmit}
                isPosting={isPosting}
                error={error}
                onCancel={closeModal}
            />
        </Modal>
    );
};

interface RevokeAdminMfaModalProps {
    user: AdminUser;
}

export default RevokeAdminMfaModal;
